import { useCallback } from 'react';
import type { TrialFeature } from '@discover-frontend/components';

import { postTrialUsageLog, type TrialUsageLogPayload } from '../../request';

export type BlockedTrialFeatureClick = {
  feature?: TrialFeature;
  category?: string;
};

export const trackBlockedTrialFeatureClick = ({
  feature,
  category,
}: BlockedTrialFeatureClick) => {
  if (!feature) return;

  const payload: TrialUsageLogPayload = { feature };

  if (category) payload.extra_info = JSON.stringify({ category_id: category });

  postTrialUsageLog(payload).catch(() => undefined);
};

export const usePostTrialUsageLog = () =>
  useCallback(trackBlockedTrialFeatureClick, []);
